import { Stack } from "@mui/material";

function DeleteBatchesDialog({ content, footer }) {
  return (
    <>
      <Stack padding="16px">{content}</Stack>
      {footer}
    </>
  );
}
export default DeleteBatchesDialog;
